import React from 'react';
import { useAuth } from '../auth/cognito.js';

export default function Layout({ children, navigate, currentView, specLabel, profileName, fullBleed }) {
  const { logout } = useAuth();

  const navBtn = (label, path, view) => (
    <button
      onClick={() => navigate(path)}
      className={`cb-nav-btn${currentView === view ? ' active' : ''}`}
    >
      {label}
    </button>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <header className="cb-header" role="banner">
        <h1><span className="cb-logo" aria-hidden="true" />CSS Profile Decision-Tree Tester</h1>
        <div className="meta">
          {specLabel && <>Spec: <span className="cb-pill">{specLabel}</span></>}
          {profileName && <>Profile: <span className="cb-pill">{profileName}</span></>}
        </div>
        <nav className="cb-nav" aria-label="Main">
          {navBtn('Builder', '/', 'builder')}
          {navBtn('Personas', '/personas', 'personas')}
          {navBtn('Specs', '/specs', 'specs')}
          {navBtn('Diff', '/diff', 'diff')}
          <button onClick={logout} className="cb-nav-btn" aria-label="Sign out">Sign out</button>
        </nav>
      </header>
      {fullBleed ? children : <div className="cb-page">{children}</div>}
    </div>
  );
}
